var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-item',{attrs:{"deep":_vm.deep,"bordered":"","icon":false}},[_c('base-loader',{class:_vm.$style.loader})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }